<ac-card>
  <ac-card-content>
    <div class="purchase-dialog">
      @if (_3dsState() && !_3dsState()!.challengeComplete) {
        <app-coinflow-challenge-modal
        [_3dsData]="_3dsState()!"
        (challengeComplete)="coinflowChallengeComplete()"
        (closeModal)="close.emit()"
      />
      } @else if (paymentMethodsLoading()) {
        <div class="ac-ctr ac-flex" [style.margin]="'auto'">
          <ac-loading type="spinner" [size]="32" />
        </div>
      } @else if (!newCard()) {
        @if (verifyCvv() && savedPaymentMethod()) {
          <app-purchase-dialog-header
            title="Verify CVV"
            (close)="close.emit()"
            (back)="verifyCvv.set(false)"
          />
          <div class="purchase-dialog__card-form">
            <div class="purchase-dialog__card-form-row ac-flex ac-ctr">
              <div class="purchase-dialog__saved-card">
                <div class="purchase-dialog__saved-card-row purchase-dialog__saved-card-name-row">
                  <div class="purchase-dialog__saved-card-name">
                    {{ savedPaymentMethod()?.label }}
                  </div>
                  <div class="purchase-dialog__saved-card-number">
                    <span class="purchase-dialog__saved-card-number-prefix"
                      >•••• •••• •••• </span
                    ><span class="ac-title-lg">{{
                      savedPaymentMethod()?.metadata?.last4
                    }}</span>
                  </div>
                </div>
                <div class="purchase-dialog__saved-card-row">
                  <div class="purchase-dialog__saved-card-row purchase-dialog__saved-card-expiry-row">
                    <div class="purchase-dialog__saved-card-expiry">
                      <div class="purchase-dialog__saved-card-expiry-label">
                        EXP
                      </div>
                      <div class="purchase-dialog__saved-card-expiry-value">
                        ••/••
                      </div>
                    </div>
                    <div class="purchase-dialog__saved-card-expiry">
                      <div class="purchase-dialog__saved-card-expiry-label">
                        CVV
                      </div>
                      <div class="purchase-dialog__saved-card-expiry-value">
                        •••
                      </div>
                    </div>
                  </div>
                  <div class="purchase-dialog__saved-card-logo">
                    @switch (savedPaymentMethod()?.metadata?.cardType) {
                      @case ('VISA') {
                        <ac-icon iconKey="payment:saved_visa" [size]="32" />
                      } @case ('MSTR') {
                        <ac-icon iconKey="payment:saved_mastercard" [size]="32" />
                      } @case ('AMEX') {
                        <ac-icon iconKey="payment:saved_amex" [size]="32" />
                      } @case ('DISC') {
                        <ac-icon iconKey="payment:saved_discover" [size]="32" />
                      } @default {
                        <ac-icon iconKey="payment:debit_credit_card" [size]="32" />
                      }
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="purchase-dialog__card-form-row ac-flex ac-ctr">
              <div class="purchase-dialog__card-input-wrapper" [style.width]="'100%'">
                <div class="purchase-dialog__card-input-label">
                  CVV
                  <div
                    class="purchase-dialog__card-input-label-info"
                    [matTooltipDisabled]="false"
                    matTooltip="Your CVV is the 3-digit number on the back of your card next to the signature.">
                    <ac-icon iconKey="hr:info" [size]="16" />
                  </div>
                </div>
                @for (args of [savedCardFormArgs()]; track args.token) {
                  <lib-coinflow-card-form #savedCardChild [args]="args" />
                }
              </div>
            </div>
            <app-billing-name-warning [fullName]="fullName()" />
            <button
              mat-flat-button
              class="ac-btn-lg"
              (click)="submit(); $event.preventDefault()"
              [loading]="loading() || !!purchaseQuery()">
              Verify and Pay {{ amount() | currency : 'USD' : 'symbol-narrow' }}
            </button>
          </div>
        }
      } @else {
        @if (addressDone()) {
          <app-purchase-dialog-header
            title="Complete Purchase"
            (close)="close.emit()"
            (back)="addressDone.set(false)"
          />
          <div class="purchase-dialog__card-form">
            @if (_3dsState()?.challengeComplete) {
              @if (_3dsState()!.last4) {
                <div class="purchase-dialog__card-form-row">
                  <div class="purchase-dialog__card-input-wrapper">
                    <div class="purchase-dialog__card-input-label">Card Number</div>
                    <mat-form-field subscriptSizing="dynamic">
                      <input
                        matInput
                        [disabled]="true"
                        [value]="'...' + _3dsState()!.last4"
                      />
                    </mat-form-field>
                  </div>
                </div>
              }
              <div class="purchase-dialog__card-form-row">
                <div class="purchase-dialog__card-input-wrapper">
                  <div class="purchase-dialog__card-input-label">Expiry</div>
                  <mat-form-field subscriptSizing="dynamic">
                    <input
                      matInput
                      placeholder="MM/YY"
                      pattern="(0?[1-9]|1[0-2])\/(\d{2})"
                      [value]="_3dsState()!.expiry"
                      [disabled]="true"
                    />
                  </mat-form-field>
                </div>
                <div class="purchase-dialog__card-input-wrapper">
                  <div class="purchase-dialog__card-input-label">CVC</div>
                  <mat-form-field subscriptSizing="dynamic">
                    <input matInput value="***" [disabled]="true" />
                  </mat-form-field>
                </div>
              </div>
              <app-purchase-receipt [package]="purchaseSelection()" />
              <app-billing-name-warning [fullName]="fullName()" />
              <button
                mat-flat-button
                type="button"
                [loading]="loading() || !!purchaseQuery()"
                (click)="submit3DS(); $event.preventDefault()"
                class="ac-btn-lg">
                Pay {{ amount() | currency : 'USD' : 'symbol-narrow' }}
              </button>
            } @else {
              <div class="purchase-dialog__card-input-wrapper">
                <div class="purchase-dialog__card-input-label">Card Details</div>
                <lib-coinflow-card-form #newCardChild [args]="newCardFormArgs" />
              </div>
              <app-purchase-receipt [package]="purchaseSelection()" />
              <app-billing-name-warning [fullName]="fullName()" />
              <button
                mat-flat-button
                class="ac-btn-lg"
                (click)="submit(); $event.preventDefault()"
                [loading]="loading() || !!purchaseQuery()">
                Pay {{ amount() | currency : 'USD' : 'symbol-narrow' }}
              </button>
            }
          </div>
        } @else {
          <app-purchase-dialog-header title="Billing Address" (close)="close.emit()" (back)="back.emit()" />
          <form [formGroup]="cardPurchaseForm" class="purchase-dialog__crypto-form">
            @if (savedAddress()) {
              <div class="purchase-dialog__card-form-row">
                <mat-checkbox
                  [checked]="useSavedAddress()"
                  (change)="toggleUseSavedAddress($event.checked)">
                  Use Saved Address
                </mat-checkbox>
              </div>
            }
            <div class="purchase-dialog__card-form-row purchase-dialog__card-form-row--readonly">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>First Name</mat-label>
                <input
                  matInput
                  required
                  formControlName="firstName"
                  [minlength]="2"
                  [readonly]="true"
                />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Last Name</mat-label>
                <input
                  matInput
                  required
                  formControlName="lastName"
                  [minlength]="2"
                  [readonly]="true"
                />
              </mat-form-field>
            </div>
            <div class="purchase-dialog__card-form-row">
              <mat-autocomplete #auto="matAutocomplete">
                @if (!showFullAddress() && !useSavedAddress()) {
                  @for (option of places(); track option.value) {
                    <mat-option
                      [value]="option.text"
                      (onSelectionChange)="selectAutocompleteAddress(option.value)">
                      {{ option.text }}
                    </mat-option>
                  }
                }
              </mat-autocomplete>

              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Address</mat-label>
                <input
                  matInput
                  required
                  (change)="$event.preventDefault()"
                  formControlName="address1"
                  placeholder="Street Address"
                  class="purchase-dialog__autocomplete-input"
                  [matAutocomplete]="auto"
                  [readonly]="useSavedAddress()"
                />
              </mat-form-field>
            </div>

            <div class="purchase-dialog__card-form-row">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Address Line 2</mat-label>
                <input matInput formControlName="address2" [readonly]="useSavedAddress()" />
              </mat-form-field>
            </div>
            <div class="purchase-dialog__card-form-row">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>City</mat-label>
                <input matInput required formControlName="city" [readonly]="useSavedAddress()" />
              </mat-form-field>
            </div>
            <div class="purchase-dialog__card-form-row">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>State</mat-label>
                <input matInput required formControlName="state" [readonly]="useSavedAddress()" />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Zip</mat-label>
                <input matInput required formControlName="zip" [readonly]="useSavedAddress()" />
              </mat-form-field>
            </div>
            <div class="purchase-dialog__card-form-row">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>Country</mat-label>
                <input matInput required formControlName="country" [readonly]="useSavedAddress()" />
              </mat-form-field>
            </div>
            <div class="purchase-dialog__card-form-row">
              <button
                mat-flat-button
                class="ac-btn-lg"
                (click)="submitAddress(); $event.preventDefault()">
                Continue
              </button>
            </div>
          </form>
        }
      }
      @if (nameMismatchDeclined()) {
        <app-name-mismatch-notice (contactSupport)="close.emit('contact-support')" />
      }
    </div>
  </ac-card-content>
</ac-card>
